import { CustomFormInputField, CustomFormReportData } from "../DTOs";
import { assertNever } from "../util";

export const customFormHelper =
{
    getFieldValues
}

function getFieldValues(field:CustomFormInputField, report:CustomFormReportData):{val:string, label:string}[]
{
    const type = field.type;
    if(type === 'RadioButtonColumn' || type === 'RadioButtonRow')
    {
        return field.options.map(o => ({ val:o.value, label:o.reportText }));
    }
    else if(type === 'MatrixRadioButtons')
    {
        const allOptions = field.sections.flatMap(s => s.rows.flatMap(r => r?.options));
        return allOptions.filter(o => o !== undefined && o !== null)
            .map(o => ({val:o.value, label:o.reportText}));

    }
    else if(type === 'Suggester' || type === 'FreeText')
    {
        const values:string[] = [];
        for(const sr of report.segmentReports)
        {
            for(const ds of sr.dataSelections)
            {
                if(ds.fieldId === field.fieldId)
                {
                    for(const s of ds.selection)
                        if(!values.includes(s.value))
                            values.push(s.value);
                }   
            }
        }
        return values.map(v => ({ val:v, label:v }));
    }
    else if(type === 'FileUpload' || type === 'CustomComponent')
    {
        return [];
    }

    else
        assertNever(type);
}